import { render, staticRenderFns } from "./BillDetail.vue?vue&type=template&id=48a9531c&scoped=true"
import script from "./BillDetail.vue?vue&type=script&lang=js"
export * from "./BillDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a9531c",
  null
  
)

export default component.exports